import {gsap} from "gsap";
import App from "../../../templates/src/App/App";

const FormWarning = {

    show(form){
        const el = form.find('.formWarning');
        if(!el.length) return;
        if(App.debug) console.log('FormWarning.show() ->', el);

        el.find('.close').click((evt)=>{
            gsap.to(el, {height: 0});
        })

        gsap.set(el, {height: 'auto'})
        gsap.from(el, {height: 0})
    },

    hide(form){
        const el = form.find('.formWarning');
        if(!el.length) return;
        if(App.debug) console.log('FormWarning.show() ->', el)

        gsap.to(el, {height: 0});
    }
}

export default FormWarning